<!-- Journey Details Removed -->

<div class="bg-tl-blue h-14"></div>

<div class="bg-tl-grey py-6 px-6">
  <div class="container mx-auto">
    <div class="space-y-1">
      <p class="text-tl-dark-blue font-bold text-xl">Corteva Database</p>
      <p class="text-gray-500 text-sm">Upload participants details in bulk</p>
    </div>
  </div>
</div>


<div class="container mx-auto text-black py-6 ">
  <!-- Upload Section -->
  <div class="bg-[#efefef] rounded-xl border p-6 mb-6">
    <div class="flex-1">
      <h2 class="text-xl font-bold text-tl-dark-blue mb-4">Upload Participants</h2>
      
      <div class="flex items-stretch gap-6">
        <!-- Step 1: Download Template -->
        <div class="flex-1 text-center">
            <p class="mb-2">
            <span class="text-gray-500 text-sm">Step 1 : </span>
            <span class="text-tl-button-blue font-semibold text-sm">Download File Format</span>
            </p>
            <div class="flex flex-col items-center gap-2">
            <button
                (click)="downloadTemplate()"
                class="w-16 h-16 rounded-xl bg-[#f0f0f0] flex items-center justify-center hover:bg-gray-100 transition-colors"
            >
                <img src="/assets/others/download_sheet.png"/>
            </button>
            <p class="text-gray-400 text-sm font-medium leading-tight">
                Download Corteva<br />participant format
            </p>
            </div>
        </div>

        <!-- Vertical Separator -->
        <div class="w-px bg-[#cdcdcd]"></div>

        <!-- Step 2: Upload File -->
        <div 
          class="flex-1 text-center"
          (dragover)="$event.preventDefault()"
          (drop)="onDrop($event)"
        >
          <p class="mb-2">
            <span class="text-gray-500 text-sm">Step 2 : </span>
            <span class="text-tl-button-blue font-semibold text-sm">Upload filled list</span>
          </p>

          <div class="flex flex-col items-center gap-2">
            <label class="w-16 h-16 rounded-xl bg-[#f0f0f0] flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer">
              <input
                type="file"
                accept=".xlsx,.xls,.csv"
                (change)="onFileSelected($event)"
                class="hidden"
              />
              <img src="/assets/others/upload_sheet.png"/>
            </label>
            <p class="text-gray-400 text-sm font-medium leading-tight">
              Upload participant<br />details in bulk
            </p>
          </div>
        
          @if (uploadedFile) {
            <p class="text-tl-button-blue text-xs mt-2 font-medium">
              {{ uploadedFile.name }}
            </p>
            <button 
                (click)="uploadFile()"
                [disabled]="isUploading"
                class="mt-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] text-white rounded-[1.5rem] text-xs px-6 font-bold py-2 bg-tl-button-blue focus:outline-none disabled:opacity-50 uppercase tracking-wide"
            >
                @if (isUploading) {
                    <app-loading-spinner></app-loading-spinner>
                } @else {
                    Upload
                }
            </button>
          }

          @if (uploadProgress > 0 && uploadProgress < 100) {
            <div class="mt-4 max-w-xs mx-auto">
                <div class="w-full bg-gray-200 rounded-full h-2">
                <div
                    class="bg-tl-button-blue h-2 rounded-full transition-all"
                    [style.width.%]="uploadProgress"
                ></div>
                </div>
                <p class="text-center text-sm text-gray-500 mt-1">{{ uploadProgress }}%</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Participants List Section -->
  <div class="bg-white rounded-xl border p-6">
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-xl font-bold text-tl-dark-blue">Participants List</h2>
      <div class="flex gap-2 w-auto">
        <input 
          type="text" 
          placeholder="Search by email..." 
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange($event)"
          (keydown.enter)="onSearch()"
          class="font-medium lg:w-64 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border sm:text-sm rounded focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5  placeholder-gray-400 text-black focus:outline-none"
        />
        <button 
          (click)="onSearch()"
          class="px-4 py-2 bg-tl-button-blue text-white rounded-lg font-semibold hover:bg-opacity-90 transition-colors"
        >
          Search
        </button>
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full text-left border-collapse">
        <thead>
          <tr class="text-gray-500 border-b border-gray-200">
            <th class="py-3 px-4 font-semibold text-sm">Name</th>
            <th class="py-3 px-4 font-semibold text-sm">Email</th>
            <th class="py-3 px-4 font-semibold text-sm">Designation</th>
            <th class="py-3 px-4 font-semibold text-sm">Mobile</th>
            <th class="py-3 px-4 font-semibold text-sm">CU/Zone</th>
            <th class="py-3 px-4 font-semibold text-sm">State</th>
            <th class="py-3 px-4 font-semibold text-sm">Territory</th>
            <th class="py-3 px-4 font-semibold text-sm">Reporting Manager</th>
            <th class="py-3 px-4 font-semibold text-sm">Actions</th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading) {
            <tr>
              <td colspan="9" class="py-12 text-center text-gray-500">
                <div class="flex flex-col items-center justify-center gap-3">
                  <app-loading-spinner></app-loading-spinner>
                  <span>Loading participants...</span>
                </div>
              </td>
            </tr>
          } @else {
          @for (participant of filteredParticipants; track participant.email) {
            <tr class="border-b border-gray-100 hover:bg-gray-50">
              <td class="py-3 px-4 text-sm text-gray-800">{{ participant.name }}</td>
              <td class="py-3 px-4 text-sm text-gray-600">{{ participant.email }}</td>
              <td class="py-3 px-4 text-sm text-gray-600">{{ participant.designation }}</td>
              <td class="py-3 px-4 text-sm text-gray-600">{{ participant.mobileNumber }}</td>
              <td class="py-3 px-4 text-sm text-gray-600">{{ participant.zone || participant.cuZone }}</td>
              <td class="py-3 px-4 text-sm text-gray-600">{{ participant.state }}</td>
              <td class="py-3 px-4 text-sm text-gray-600">{{ participant.territory }}</td>
              <td class="py-3 px-4 text-sm text-gray-600">{{ participant.reportingManagerName }}</td>
              <td class="py-3 px-4 text-sm flex gap-2 items-center">
                <button 
                  (click)="onEdit(participant)" 
                class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] text-white rounded-[1.5rem] text-xs px-6 font-bold py-1.5 bg-tl-button-blue focus:outline-none disabled:opacity-50 uppercase tracking-wide"
                  title="Edit"
                >
                  <span class="text-sm">Edit</span>
                </button>
                <button 
                  (click)="onDelete(participant)" 
                    class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] cursor-pointer w-fit self-center text-white font-semibold rounded-[1.5rem] text-lg px-4 py-0.5 text-center bg-tl-red focus:outline-none disabled:opacity-50"
                  title="Delete"
                >
                  <span class="text-sm">Delete</span>
                </button>
              </td>
            </tr>
          } @empty {
            @if (!isLoading) {
              <tr>
                <td colspan="9" class="py-8 text-center text-gray-500">
                  No participants found.
                </td>
              </tr>
            }
          }
          }
        </tbody>
      </table>
    </div>

    </div>
  </div>

  <!-- Load More Button -->
  @if (!searchTerm && !isLoading) {
    <div class="mt-6 flex justify-center pb-6">
      <button 
        (click)="loadMore()" 
        [disabled]="isLoadingMore"
        class="px-6 py-2 bg-tl-button-blue text-white rounded-lg font-semibold hover:bg-opacity-90 transition-colors disabled:opacity-50 flex items-center gap-2"
      >
        @if (isLoadingMore) {
          <span class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
          Loading...
        } @else {
          Load More
        }
      </button>
    </div>
  }

<!-- Edit Modal -->
@if (showEditModal) {
<div class="fixed text-black inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
  <div class="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
    <div class="p-6 border-b border-gray-100 flex justify-between items-center sticky top-0 bg-white">
      <h3 class="text-xl font-bold text-tl-dark-blue">Edit Participant</h3>
      <button (click)="closeModal()" class="text-gray-400 hover:text-gray-600">
        <span class="text-xl font-bold">&times;</span>
      </button>
    </div>
    
    <div class="p-6 space-y-4">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Name -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Name</label>
          <input 
            type="text" 
            [(ngModel)]="selectedParticipant.name" 
            class="w-full px-3 py-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>

        <!-- Email -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input 
            type="email" 
            [(ngModel)]="selectedParticipant.email" 
            class="w-full px-3 py-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>

        <!-- Designation -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Designation</label>
          <input 
            type="text" 
            [(ngModel)]="selectedParticipant.designation" 
            class="w-full px-3 py-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>

        <!-- Mobile -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
          <input 
            type="text" 
            [(ngModel)]="selectedParticipant.mobileNumber" 
            class="w-full px-3 py-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>

        <!-- Zone -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Zone (CU Zone)</label>
          <input 
            type="text" 
            [(ngModel)]="selectedParticipant.zone"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="selectedParticipant.cuZone = $event" 
            class="w-full px-3 py-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>

        <!-- State -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">State</label>
          <input 
            type="text" 
            [(ngModel)]="selectedParticipant.state" 
            class="w-full px-3 py-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>

        <!-- Territory -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Territory</label>
          <input 
            type="text" 
            [(ngModel)]="selectedParticipant.territory" 
            class="w-full px-3 py-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>

        <!-- Reporting Manager -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Reporting Manager</label>
          <input 
            type="text" 
            [(ngModel)]="selectedParticipant.reportingManagerName" 
            class="w-full px-3 py-2 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>
      </div>
    </div>

    <div class="p-6 border-t items-center border-gray-100 flex justify-end gap-3 sticky bottom-0 bg-white">
      <button 
        (click)="closeModal()"
   class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] cursor-pointer w-fit self-center text-white font-semibold rounded-[1.5rem] text-lg px-4 py-0.5 text-center bg-tl-red focus:outline-none disabled:opacity-50"
                
      >
        Cancel
      </button>
      <button 
        (click)="saveUpdate()"
        [disabled]="isUpdating"
                class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] text-white rounded-[1.5rem] text-xs px-6 font-bold py-2 bg-tl-button-blue focus:outline-none disabled:opacity-50 uppercase tracking-wide"
      >
        @if (isUpdating) {
          Saving...
        } @else {
          Save Changes
        }
      </button>
    </div>
  </div>
</div>
}

<!-- Delete Confirmation Modal -->
@if (showDeleteModal) {
<div class="fixed text-black inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
  <div class="bg-white rounded-xl shadow-xl w-full max-w-sm overflow-hidden">
    <div class="p-6 text-center">
      <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h3 class="text-xl font-bold text-gray-900 mb-2">Delete Participant</h3>
      <p class="text-gray-500 mb-6">
        Are you sure you want to delete <span class="font-semibold text-gray-700">{{ participantToDelete?.name }}</span>? 
        This action cannot be undone.
      </p>
      
      <div class="flex gap-3 justify-center">
        <button 
          (click)="closeDeleteModal()"
          class="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg font-medium transition-colors"
        >
          Cancel
        </button>
        <button 
          (click)="confirmDelete()"
          [disabled]="isDeleting"
          class="px-6 py-2 bg-red-600 text-white rounded-lg font-bold hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center gap-2"
        >
          @if (isDeleting) {
            <span>Deleting...</span>
          } @else {
            <span>Delete</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
}
